import {
  default as instituteSelector,
  default as selector,
} from 'modules/Auth/selectors'
import rolesApi from 'utils/corporateRequest'
import request from 'utils/request'
import ErrorMessage from '../../utils/ErrorMessage'
import SuccessMessage from '../../utils/SuccessMessage'
export const SET_ROLES_LIST = 'institute/SET_ROLES_LIST'
export const SET_JOB_DETAILS = 'institute/SET_JOB_DETAILS'
export const UPDATE_SINGLE_ROLE_DATA = 'institute/UPDATE_SINGLE_ROLE_DATA'
export const SET_JOB_ID = 'institute/SET_JOB_ID'
export const SET_CITIES = 'institute/SET_CITIES'
export const SET_ABOUT_US = 'institute/SET_ABOUT_US'
export const SET_PAGE_NUM = 'institute/SET_PAGE_NUM'

export const setRolesList = data => {
  return {
    type: SET_ROLES_LIST,
    data,
  }
}

export const setJobDetails = data => {
  return {
    type: SET_JOB_DETAILS,
    data,
  }
}
export const setAboutUs = data => {
  return {
    type: SET_ABOUT_US,
    data,
  }
}
export const updateSingleRoleData = data => {
  return {
    type: UPDATE_SINGLE_ROLE_DATA,
    data,
  }
}

export const setJobId = id => {
  return {
    type: SET_JOB_ID,
    id,
  }
}
export const setCities = data => {
  return {
    type: SET_CITIES,
    data,
  }
}
export const setPageNum = data => {
  return {
    type: SET_PAGE_NUM,
    data,
  }
}

export const getRolesListData =
  (setLoading, query = null) =>
  async (dispatch, getState) => {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
    const institute_tier = instituteSelector.getInstituteDetails(state).tier
    setLoading(true)
    try {
      const info = await rolesApi.get(
        `/corporates/jobsByInstitute/${institute_id}/lists?tier=tier${institute_tier}&${query}`
      )
      dispatch(setRolesList(info?.data?.data))
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
export const getJobDetails = role => async (dispatch, getState) => {
  dispatch(setJobDetails({}))
  let roleId = role.id
  let corporateId = role.corporateId
  const state = getState()
  const institute_id = instituteSelector.getInstituteDetails(state).id
  try {
    const info = await rolesApi.get(
      `/corporates/${corporateId}/jobs/${roleId}/instituteCampus/${institute_id}`
    )
    dispatch(setJobDetails(info.data.data || {}))
  } catch (error) {}
}
export const acceptOrReject = jobId => async (dispatch, getState) => {
  const state = getState()
  const institute_id = instituteSelector.getInstituteCampusId(state)
  try {
    await rolesApi.post(
      `/corporates/jobs/${jobId}/jobsByInstitute/${institute_id}/updateStatus`
    )
  } catch (error) {
    //console.log(error)
  }
}
export const updateRoleData = payload => async (dispatch, getState) => {
  const state = getState()
  const institute_id = instituteSelector.getInstituteDetails(state).id
  let data = { saved: payload.saved }
  try {
    const info = await rolesApi.post(
      `/corporates/jobs/${payload.id}/jobsByInstitute/${institute_id}/saved`,
      data
    )
    if (info?.status === 200) {
      SuccessMessage('Updated successfully')
      let rolesCopy = { ...state.roles.rolesList }
      let index = rolesCopy?.result.findIndex(
        val => payload.id === val.jobRoles.id
      )
      if (index != -1) {
        if (rolesCopy?.result[index]) {
          rolesCopy.result[index].saved = +payload.saved
          dispatch(setRolesList(rolesCopy))
        }
      }
      let roleDetails = { ...state.roles.singleRoleDetails }
      if (roleDetails.id === payload.id) {
        roleDetails.jobRoleInstituteMap[0].saved = +payload.saved
        dispatch(setJobDetails(roleDetails || {}))
      }
    }
  } catch (error) {}
}
export const corporateAboutUs = corpId => async (dispatch, getState) => {
  try {
    const info = await rolesApi.get(`/corporates/${corpId}`)

    dispatch(setAboutUs(info?.data?.data))
  } catch (error) {}
}
export const getCities =
  (query = 'currentPage=0') =>
  async (dispatch, getState) => {
    try {
      const info = await request.get(`/search/cities?pageLimit=50&${query}`)
      dispatch(setCities(info?.data?.data?.result))
    } catch (error) {}
  }
export const updatePageNum = count => async (dispatch, getState) => {
  dispatch(setPageNum(count))
}

export const jobSharingEmail =
  ({ payload }, subEventId) =>
  async (dispatch, getState) => {
    const state = getState()
    let EventId = subEventId ? `?subEventId=${subEventId}` : ''
    const userId = selector.getUserId(state)
    try {
      const result = await request.post(
        `/users/${userId}/jobSharing${EventId}`,
        payload
      )
      SuccessMessage('E-mail Send Successfully.')
      return result
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getUserCorpList = corpId => async (dispatch, getState) => {
  try {
    const response = await request.get(`/user?coporateId=${corpId}&status=true`)

    return response?.data?.data
  } catch (error) {
    return error
  }
}
